/**记录当前所选的挂号的相关信息 */
function copyObj(obj){
	if(obj == null){
		console.log("请传入非空变量")
		return null
	}else{
		return JSON.parse(JSON.stringify(obj))
	}
}
const state = {
	dept: {
		level1:{}, // 一级科室
		level2:{}, // 二级科室
		level3:{}, // 三级科室
	},
	doctor: {},
	way: '', //挂号方式：dr:当日挂号，yy:预约挂号
	currentSource:{}, // 当前用户时段号源列表
	yyhx: '', //预约号序
	apptCode:'', // 挂号预约码
	sourceInfo: '', //就诊时间
	timeInfo: {
		date: '', //这里用string 2018-06-17
		week: '', // 星期几
		flag: '', // 1 上午 2 下午 3白天 4 晚上 5 昼夜 
		txt: '', // 1 上午 2 下午 3白天 4 晚上 5 昼夜 
		pbxh: '',  //排班序号
	},
	fee: {
		regFee: '', // 挂号费
		reatFee: '', // 诊断费
		totalFee:'', // 挂号费 + 诊断费
	},
	uniqueIdType: '', //唯一编号类型（0支付宝，1微信）
	patient:{} // 就诊人信息
}

const mutations = {
	// 修改科室信息
//	updateDept(state, dept) {
//		for (let key in dept) {
//			if (dept.hasOwnProperty(key)) {
//				state.dept[key] = dept[key]
//			}
//		}
//	},
	// 修改一级科室信息
	updateDeptLevel1(state, dept) {
		for (let key in dept) {
			if (dept.hasOwnProperty(key)) {
				state.dept.level1[key] = dept[key]
			}
		}
	},
	// 修改二级科室信息
	updateDeptLevel2(state, dept) {
		for (let key in dept) {
			if (dept.hasOwnProperty(key)) {
				state.dept.level2[key] = dept[key]
			}
		}
	},
	// 修改三级科室信息
	updateDeptLevel3(state, dept) {
		for (let key in dept) {
			if (dept.hasOwnProperty(key)) {
				state.dept.level3[key] = dept[key]
			}
		}
	},
	// 修改医生信息
	updateDoctor(state, doctor) {
		for (let key in doctor) {
			if (doctor.hasOwnProperty(key)) {
				state.doctor[key] = doctor[key]
			}
		}
	},
	updateyyhx(state, yyhx) {
		state.yyhx = yyhx
	},
	//当前用户所选的时段号源列表
	updateCurrentSource(state,list){
		state.currentSource.currentDate = list[0].regDate
    	state.currentSource.list = copyObj(list)
	},
	updateRegisterWay(state, way) {
		state.way = way
	},
	// 修改预约时段信息
	updateSourceInfo(state, sourceInfo) {
		state.sourceInfo = sourceInfo
	},
	// 修改号段信息
	updateTimeInfo(state, timeInfo) {
		for (let key in timeInfo) {
			if (timeInfo.hasOwnProperty(key)) {
				state.timeInfo[key] = timeInfo[key]
			}
		}
	},
	// 修改挂号费用
	updateFee(state, fee) {
		for (let key in fee) {
			if (fee.hasOwnProperty(key)) {
				state.fee[key] = fee[key]
			}
		}
	},
	// 修改唯一编号类型
	updateUniqueIdType(state, type) {
		state.uniqueIdType = type
	},
	// 修改就诊人信息
	updatePatient(state, patient) {
		for (let key in patient) {
			if (patient.hasOwnProperty(key)) {
				state.patient[key] = patient[key]
			}
		}
	},
	// 修改预约码
	updateApptCode(state,code){
		state.apptCode = code
	},
}

export default {
	state,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/register.js